module.exports = __webpack_public_path__ + "img/trading.9a967036.png";